import React from 'react';
import { FileTextIcon, ClockIcon, BarChartIcon, RefreshCwIcon, ShoppingCartIcon } from 'lucide-react';
export const WhatsIncluded = () => {
  return <section className="py-12 px-4 sm:px-6 lg:px-8 bg-teal-50" data-id="element-445">
      <div className="max-w-5xl mx-auto" data-id="element-446">
        <div className="text-center mb-10" data-id="element-447">
          <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-448">
            ¿Qué incluye?
          </h2>
          <p className="text-xl text-gray-700" data-id="element-449">
            Todo lo que necesitás para transformar tu alimentación
          </p>
        </div>
        <div className="bg-white rounded-xl shadow-md overflow-hidden" data-id="element-450">
          <div className="p-6" data-id="element-451">
            <ul className="space-y-5" data-id="element-452">
              <li className="flex gap-4" data-id="element-453">
                <div className="bg-teal-100 p-2 rounded-full h-10 w-10 flex items-center justify-center flex-shrink-0" data-id="element-454">
                  <FileTextIcon className="h-5 w-5 text-teal-700" data-id="element-455" />
                </div>
                <div data-id="element-456">
                  <p className="font-medium text-gray-900" data-id="element-457">
                    +60 recetas listas en &lt;15 min
                  </p>
                  <p className="text-gray-600 text-sm" data-id="element-458">
                    Desayunos, almuerzos, cenas y snacks
                  </p>
                </div>
              </li>
              <li className="flex gap-4" data-id="element-459">
                <div className="bg-teal-100 p-2 rounded-full h-10 w-10 flex items-center justify-center flex-shrink-0" data-id="element-460">
                  <BarChartIcon className="h-5 w-5 text-teal-700" data-id="element-461" />
                </div>
                <div data-id="element-462">
                  <p className="font-medium text-gray-900" data-id="element-463">
                    Porciones sugeridas y macros orientativas
                  </p>
                  <p className="text-gray-600 text-sm" data-id="element-464">
                    Control de calorías, proteínas, grasas y carbohidratos
                  </p>
                </div>
              </li>
              <li className="flex gap-4" data-id="element-465">
                <div className="bg-teal-100 p-2 rounded-full h-10 w-10 flex items-center justify-center flex-shrink-0" data-id="element-466">
                  <FileTextIcon className="h-5 w-5 text-teal-700" data-id="element-467" />
                </div>
                <div data-id="element-468">
                  <p className="font-medium text-gray-900" data-id="element-469">Swaps y variantes</p>
                  <p className="text-gray-600 text-sm" data-id="element-470">
                    Opciones veggie y sin TACC donde corresponde
                  </p>
                </div>
              </li>
              <li className="flex gap-4" data-id="element-471">
                <div className="bg-teal-100 p-2 rounded-full h-10 w-10 flex items-center justify-center flex-shrink-0" data-id="element-472">
                  <RefreshCwIcon className="h-5 w-5 text-teal-700" data-id="element-473" />
                </div>
                <div data-id="element-474">
                  <p className="font-medium text-gray-900" data-id="element-475">
                    Actualizaciones gratis
                  </p>
                  <p className="text-gray-600 text-sm" data-id="element-476">
                    Cada nueva tanda de recetas se agrega sin costo
                  </p>
                </div>
              </li>
              <li className="flex gap-4" data-id="element-477">
                <div className="bg-teal-100 p-2 rounded-full h-10 w-10 flex items-center justify-center flex-shrink-0" data-id="element-478">
                  <ShoppingCartIcon className="h-5 w-5 text-teal-700" data-id="element-479" />
                </div>
                <div data-id="element-480">
                  <p className="font-medium text-gray-900" data-id="element-481">
                    Lista de compras y guía de batch cooking
                  </p>
                  <p className="text-gray-600 text-sm" data-id="element-482">
                    Organizá tu finde para tener comida toda la semana
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div className="mt-8 text-center" data-id="element-483">
          <a href="https://vhwt09-gz.myshopify.com/checkouts/cn/hWN3ajyOi9gyqJJTJgcXUW4g/es-ar?cart_link_id=CISumiVv&preview_theme_id=133233049643" className="inline-block bg-teal-600 hover:bg-teal-700 text-white font-bold py-3 px-8 rounded-lg shadow-lg hover:shadow-xl transition duration-300" data-id="element-484">
            Quiero todo hoy solo por $19.990
          </a>
        </div>
      </div>
    </section>;
};